import React, {Fragment} from "react";
import Translate from "../Translate";

export default function NsButton({
                                     nome,
                                     label,
                                     icona,
                                     type = "button",
                                     onClick = () => {
                                     },
                                     disabled = false,
                                     showLabel = true,
                                     small = false
                                 }) {

    return (
        <button
            type={type}
            id={nome}
            name={nome}
            className={"btn btn-dark " + (small ? 'btn-sm' : '')}
            onClick={onClick}
            disabled={disabled}
            data-toggle="tooltip" title={label}
        >
            {
                icona &&
                <Fragment><i className={icona}/></Fragment>
            }
            {
                label && showLabel &&
                <Translate>{label}</Translate>
            }
        </button>
    )
}